import { createI18n } from 'vue-i18n'
import removeTodo from '@/locales/scripts/removeTodo'
import ja from '@/locales/locales/ja.json'
import en from '@/locales/locales/en.json'
import es from '@/locales/locales/es.json'
import fr from '@/locales/locales/fr.json'
import pt from '@/locales/locales/pt-pt.json'
import de from '@/locales/locales/de.json'
import it from '@/locales/locales/it.json'

const i18n = createI18n({
  locale: 'en',
  fallbackLocale: ['en'],
  messages: {
    en: removeTodo(en),
    ja: removeTodo(ja),
    es: removeTodo(es),
    fr: removeTodo(fr),
    pt: removeTodo(pt),
    de: removeTodo(de),
    it: removeTodo(it),
  },
  datetimeFormats: {
    en: {
      long: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      },
    },
    ja: {
      long: {
        era: 'long',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        weekday: 'long',
        hour12: true,
        timeZoneName: 'long',
      },
    },
    es: {
      long: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      },
    },
    fr: {
      long: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      },
    },
    pt: {
      long: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      },
    },
    de: {
      long: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      },
    },
    it: {
      long: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      },
    },
  },
})

export default i18n
